import { useField } from 'react-final-form';
import { useSaveNotes } from '../../hooks/useSaveNotes';
import { ReusableNotesField } from './ReusableNotesField';

type Props = {
  sectionId: string;
  onSubmit?: () => void;
  skipSave?: boolean;
  aiNotes?: boolean;
  autoFocus?: boolean;
};

export const NotesField = ({
  sectionId,
  aiNotes = false,
  onSubmit = () => {},
  skipSave = false,
  autoFocus = true
}: Props) => {
  const {
    input: { value: vehicleId }
  } = useField(`vehicleId`);

  const save = useSaveNotes(sectionId, vehicleId);

  const setNotes = (notes: string | null, fieldName?: string) => {
    onSubmit();
    if (!skipSave) {
      save(notes, fieldName);
    }
  };

  return (
    <ReusableNotesField
      sectionId={sectionId}
      aiNotes={aiNotes}
      onSubmit={onSubmit}
      skipSave={skipSave}
      save={setNotes}
      autoFocus={autoFocus}
    />
  );
};
